// Window events dispatched by containers/GTM once gtm.js finishes loading (or
// fails to, e.g. blocked by an ad blocker). Alongside the events, GTM sets
// window.__gtmLoaded / window.__gtmFailed so late subscribers can check state.
export const GTM_LOADED_EVENT = 'gtm:loaded';
export const GTM_ERROR_EVENT = 'gtm:error';

/**
 * Runs `callback` once GTM has loaded (or failed). If GTM is already settled
 * it runs synchronously. Falls back to running after `timeoutMs` so a page
 * without a GTM rendering, or a very slow gtm.js, never blocks the caller.
 * Returns a cleanup function that cancels the pending callback.
 */
export const runAfterGTM = (callback, timeoutMs) => {
  if (typeof window === 'undefined') return () => {};
  if (window.__gtmLoaded || window.__gtmFailed) {
    callback();
    return () => {};
  }
  let done = false;
  let timer;
  const run = () => {
    if (done) return;
    done = true;
    clearTimeout(timer);
    window.removeEventListener(GTM_LOADED_EVENT, run);
    window.removeEventListener(GTM_ERROR_EVENT, run);
    callback();
  };
  window.addEventListener(GTM_LOADED_EVENT, run);
  window.addEventListener(GTM_ERROR_EVENT, run);
  timer = setTimeout(run, timeoutMs);
  return () => {
    done = true;
    clearTimeout(timer);
    window.removeEventListener(GTM_LOADED_EVENT, run);
    window.removeEventListener(GTM_ERROR_EVENT, run);
  };
};
